(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function setAccordionState(heading, open) {
    var col = heading.closest('.tcb-footer__nav-col');
    if (!col) return;
    col.classList.toggle('is-open', open);
    heading.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initFooter(section) {
    if (!section || section.dataset.tcbFooterInit === 'true') return;
    section.dataset.tcbFooterInit = 'true';

    var headings = section.querySelectorAll('.tcb-footer__nav-col h3');

    headings.forEach(function (heading, index) {
      var panel = heading.nextElementSibling;
      if (!panel || !panel.classList.contains('tcb-footer__nav-panel')) return;

      var panelId = 'tcb-footer-panel-' + section.dataset.sectionId + '-' + index;
      panel.id = panelId;
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', isMobile() ? '0' : '-1');
      heading.setAttribute('aria-controls', panelId);
      heading.setAttribute('aria-expanded', 'false');

      function toggle() {
        if (!isMobile()) return;
        setAccordionState(heading, !heading.closest('.tcb-footer__nav-col').classList.contains('is-open'));
      }

      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', function (event) {
        if (!isMobile()) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });

    function syncViewport() {
      var mobile = isMobile();
      headings.forEach(function (heading) {
        heading.setAttribute('tabindex', mobile ? '0' : '-1');
        if (!mobile) {
          setAccordionState(heading, false);
        }
      });
    }

    syncViewport();
    var mq = window.matchMedia(MOBILE_MQ);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', syncViewport);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(syncViewport);
    }
  }

  function boot() {
    document.querySelectorAll('.tcb-premium-footer').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.tcb-premium-footer') || event.target.closest('.tcb-premium-footer');
    if (section) initFooter(section);
  });
})();
